import { useState } from 'react'

import { Button } from '../ui/button'

import FormControls from './form-controls'
import logger from '../../utils/logger'

function CommonForm({
  handleSubmit,
  buttonText,
  formControls = [],
  formData,
  setFormData,
  isButtonDisabled = false,
  buttonClass,
}) {
  const [formErrors, setFormErrors] = useState({})
  // const [isFormValid, setIsFormValid] = useState(false);

  // ================================================= || Validate all form field here || ============================================

  const validateForm = () => {
    let newErrors = {}
    let isValid = true

    // Flatten all controls including grouped ones
    const allControls = formControls.flatMap((control) =>
      control.isGrouped ? control.groupControls : [control]
    )

    allControls.forEach((controlItem) => {
      const fieldName = controlItem.name
      const fieldValue = formData[fieldName]
      const validations = controlItem.validations || []
      let fieldError = ''

      // check each validation rule on the fieldName
      for (const validation of validations) {
        // Required field validation
        if (validation.required && (!fieldValue || fieldValue === '')) {
          fieldError = validation.message || `${controlItem.label} is required`
          isValid = false
          break
        }

        // Skip other validations if field is empty and not required
        if (!fieldValue && !validation.required) continue

        // Pattern/regex validation
        if (validation.pattern && fieldValue) {
          const pattern = new RegExp(validation.pattern)
          if (!pattern.test(fieldValue)) {
            fieldError = validation.message || `Invalid ${controlItem.label} format`
            isValid = false
            break
          }
        }

        // Min length validation
        if (validation.minLength && fieldValue && fieldValue.length < validation.minLength) {
          fieldError =
            validation.message ||
            `${controlItem.label} should be at least ${validation.minLength} characters`
          isValid = false
          break
        }

        // Max length validation
        if (validation.maxLength && fieldValue && fieldValue.length > validation.maxLength) {
          fieldError =
            validation.message ||
            `${controlItem.label} should not exceed ${validation.maxLength} characters`
          isValid = false
          break
        }

        // Min value validation (for numbers)
        if (validation.min && fieldValue && Number(fieldValue) < validation.min) {
          fieldError =
            validation.message || `${controlItem.label} should be at least ${validation.min}`
          isValid = false
          break
        }

        // Max value validation (for numbers)
        if (validation.max && fieldValue && Number(fieldValue) > validation.max) {
          fieldError =
            validation.message || `${controlItem.label} should not exceed ${validation.max}`
          isValid = false
          break
        }

        // Custom validation
        if (validation.custom && typeof validation.custom === 'function') {
          const customError = validation.custom(fieldValue, formData)
          if (customError) {
            fieldError = customError
            isValid = false
            break
          }
        }
      }

      if (fieldError) {
        newErrors[fieldName] = fieldError
      }
    })

    setFormErrors(newErrors)
    return isValid
  }

  // check the form validity on the form change
  // useEffect(() => {
  //   validateForm();
  // }, [formData]);

  // if the form is valid then the form is submit
  const onSubmit = (e) => {
    e.preventDefault()

    const isValid = validateForm()

    if (isValid) {
      handleSubmit(e)
    }
  }

  return (
    <form onSubmit={onSubmit}>
      {/* render form controls here */}
      <FormControls
        formControls={formControls}
        formData={formData}
        setFormData={setFormData}
        formErrors={formErrors}
        // when the user enter data in input remove the error
        setFormErrors={setFormErrors}
      />
      <Button
        disabled={isButtonDisabled}
        type="submit"
        className={`mt-8 w-full rounded-sm text-base px-3 py-3 sm:py-6 
    ${
      isButtonDisabled
        // ? 'bg-heading-primary/50 text-gray-300 cursor-not-allowed'
        // : 'bg-heading-primary text-white hover:bg-heading-primary-400 cursor-pointer'
    } 
    ${buttonClass}`}
      >
        {buttonText || 'Submit'}
      </Button>
    </form>
  )
}

export default CommonForm
